import { useParams, Outlet } from 'react-router'

const Reports = () => {
  const { reportTab = '' } = useParams<{ reportTab: string }>()

  return (
    <div className="reports-screen">
      <Outlet />
    </div>
  )
}

export default Reports
